import React, { useEffect, useState } from 'react';
import { Search } from '.';
import { createEvent } from '../helpers';

export default ({ value, onChange, getOptions, name, ...props }) => {
  const [searchValue, setSearchValue] = useState('');
  const [shouldShowOptions, setShouldShowOptions] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const hydratedOptions = getOptions(searchValue);
  let blurTimeout;

  useEffect(() => {
    if (Object.keys(value).length && !hasSearched) {
      setHasSearched(true);
    }
  }, [value]);

  const handleEnter = () => {
    if (blurTimeout) clearTimeout(blurTimeout);
    setShouldShowOptions(true);
  };

  const handleLeave = () => {
    blurTimeout = setTimeout(() => setShouldShowOptions(false), 300);
  };

  const handleChange = ({ type, value }) =>
    onChange(createEvent({ name, value: { type, value } }));

  const handleInputChange = (event) => {
    const newInputValue = event.target.value;
    if (!newInputValue && hasSearched) {
      handleChange({});
      setHasSearched(false);
    }
    setSearchValue(newInputValue);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (!searchValue) {
        return handleChange({});
      }
      handleChange({ value: searchValue });
    }
  };

  const handleSearchClick = () => {
    if (searchValue) {
      handleChange({ value: searchValue });
    }
  };

  const handleSelectClick = (type) => () => {
    handleChange({ type, value: searchValue });
  };

  const handleSelectKeyDown = (type) => (event) => {
    if (event.key === 'Enter') {
      handleChange({ type, value: searchValue });
    }
  };

  return (
    <div
      className="search-select-container"
      onFocus={handleEnter}
      onBlur={handleLeave}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <Search
        value={searchValue}
        onChange={handleInputChange}
        onKeyDown={handleSearchKeyDown}
        onSearchClick={handleSearchClick}
        {...props}
        role="combobox"
        aria-autocomplete="none"
        aria-haspopup={true}
        aria-owns="#search-select-listbox"
        aria-expanded={searchValue && shouldShowOptions}
      />
      {shouldShowOptions && searchValue && (
        <ul
          id="search-select-listbox"
          role="listbox"
          aria-label="Search Options"
        >
          {hydratedOptions.map((option, index) => (
            <li
              key={option.label}
              tabIndex={0}
              onClick={handleSelectClick(option.value)}
              onKeyDown={handleSelectKeyDown(option.value)}
              role="option"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
